<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
  <g fill="none">
      <g transform="translate(-424 -32)translate(424 32)">
        <circle cx="12" cy="12" r="11.5" [attr.stroke]="color"/>
        <text font-family="SFUIText-Bold, SF UI Text" font-size="17" style="font-weight:bold" [style.fill]="color">
          <tspan x="9.5" y="18.5">
            i
          </tspan>
        </text>
      </g>
  </g>
</svg>
